"use strict";exports.__esModule=!0,exports.getCurrentTime=getCurrentTime,exports.hackFunction=hackFunction;/**
 * 劫持函数
 */function hackFunction(a,b,c){if("object"==typeof a&&"function"==typeof a[b]){var d=a[b],e=c(d);a[b]=e}}/**
 * 获取当前时间
 * @returns
 */function getCurrentTime(a){var b,c;return null!==(b=performance)&&void 0!==b&&b.timeOrigin&&null!==(c=performance)&&void 0!==c&&c.now?Math.round(performance.timeOrigin+(a?a:performance.now())):Date.now()}